/* ==========================================================================
   masonry.js — true masonry for the shop-all grid and the archive grid.

   CSS multi-column is the no-JS fallback, but it balances column heights and
   that leaves holes in the middle of a column. The Figma grids are true
   masonry: every tile sits directly under the previous one in its column. So
   once JS is available the items are dealt into flex columns, shortest column
   first.

   Each item carries its aspect ratio inline, so heights are known before the
   photos load and nothing jumps around.
   ========================================================================== */

(function () {
  'use strict';

  const Theme = (window.Theme = window.Theme || {});

  Theme.masonry = function (grid, options = {}) {
    if (!grid) return null;

    const itemSelector = options.itemSelector || ':scope > *';
    const colsProperty = options.colsProperty || '--grid-cols';
    const colClass = options.colClass || 'grid__col';

    // Snapshot the items once, in source order, before we start moving them.
    const items = Array.from(grid.querySelectorAll(itemSelector)).filter(
      (el) => !el.classList.contains(colClass)
    );
    if (!items.length) return null;

    let currentCols = 0;

    function readCols() {
      const raw = getComputedStyle(grid).getPropertyValue(colsProperty);
      const n = parseInt(raw, 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    }

    function layout(force) {
      const cols = readCols();
      const visible = items.filter((item) => !item.hidden);

      if (!force && cols === currentCols && grid.dataset.count === String(visible.length)) {
        return;
      }
      currentCols = cols;
      grid.dataset.count = String(visible.length);

      const columns = [];
      const heights = [];
      for (let i = 0; i < cols; i += 1) {
        const col = document.createElement('div');
        col.className = colClass;
        columns.push(col);
        heights.push(0);
      }

      const colWidth = grid.clientWidth / cols;

      visible.forEach((item) => {
        let target = 0;
        for (let i = 1; i < cols; i += 1) {
          if (heights[i] < heights[target]) target = i;
        }
        columns[target].appendChild(item);
        heights[target] += estimateHeight(item, colWidth);
      });

      grid.replaceChildren(...columns);
      // Items filtered out still need a home so they can come back later.
      items
        .filter((item) => item.hidden)
        .forEach((item) => columns[0].appendChild(item));

      grid.classList.add('is-masonry');
    }

    function estimateHeight(item, colWidth) {
      const ratioEl = item.querySelector('[style*="aspect-ratio"]') || item;
      const ratio = parseFloat(getComputedStyle(ratioEl).aspectRatio);
      const media = Number.isFinite(ratio) && ratio > 0 ? colWidth / ratio : colWidth;
      // Text under the card, if any — measured rather than guessed.
      const meta = item.querySelector('.card__meta');
      return media + (meta ? meta.offsetHeight : 0);
    }

    layout(true);

    let frame = null;
    const onResize = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => layout(true));
    };
    window.addEventListener('resize', onResize);

    return {
      relayout: () => layout(true),
      teardown() {
        window.removeEventListener('resize', onResize);
        grid.classList.remove('is-masonry');
        grid.replaceChildren(...items);
        currentCols = 0;
      }
    };
  };
})();
